import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getGlobalStore } from "@jti/commerce";
import { waitFor } from "@jti/fe-common";
import { CartMiniApp } from "./CartMiniApp";
/*
  return CartMini in compare with index.js which renders Cart Mini in a specific dom node
  this component should be used to render Cart Mini within a React tree
*/
export const CartMiniInPlace = () => {
    const [resolvedByTest, setResolvedByTest] = useState(false);
    useEffect(() => {
        waitFor(() => Boolean(getGlobalStore()), (resolvedByTest) => {
            setResolvedByTest(resolvedByTest);
        });
    }, []);
    return _jsx(CartMiniApp, { globalStoreResolved: resolvedByTest });
};
//# sourceMappingURL=CartMiniInPlace.js.map